<template>
   <div>
      <h3 class="section-title">Instructions</h3>
      <div v-if="loading" class="padt-24 mart-24 padb-24">
         <i class="fas fa-spinner fa-spin ml-orange fa-lg"></i>
      </div>
      <div v-else>
         <div class="doc-view mart-12">
            <div class="inner-doc-view">
               <pdf-viewer docpath="Instructions.pdf" title="Instructions" :downloadfiletype="downloadfiletype" :keepdefaultcss="keepdefaultcss"></pdf-viewer>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import pdfViewer from "./pdfViewer.vue"


export default {
   name: "comp",
   components: {
      'pdf-viewer': pdfViewer
   },
   data() {
      return {
         loading: true,
         downloadfiletype:4,
         keepdefaultcss: false
      };
   },
   mounted() {
      this.loading = false
	},
   methods: {
      download() {

      }
   }
};
</script>

<style scoped lang="scss">
@import "../../assets/css/colors.scss";
@import "../../assets/css/application.scss";

.doc-view {
   min-height: 600px;
   height: 600px;
   overflow-x: hidden;
   overflow-y: scroll;
   border: 1px solid #ddd;
}
.inner-doc-view {
   padding: 0;
   width: 100%;
}
.down-link {
   font-size: 0.7em;
}
</style>